/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInbox = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 21H2V11l4.512-8h11.235L22 11zM4 19h16v-6h-3.335l-2 3H9.594l-2-3H4zM16.512 5H7.748l-3.316 6h4.233l1.999 3h2.93l2-3h4.14z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgInbox as Inbox };
